/* ============================================================================
   BOGO Offer — "build your box, every 2nd bottle free" picker, on the PDP.
   CART-AWARE: reads the cart on open, never duplicates the root, and "Done"
   reconciles the cart to match the box (adds new, reduces/removes changed).

   A "your box" card row under the search shows everything selected/in cart with
   a remove control (the root scent is locked). Every 2nd bottle of the SAME size
   is free (automatic Shopify Function discounts), so progress/free are per size.
   Grid data: pre-baked CDN asset assets/bogo-catalogue.json. EliteCart owns the
   cart; we add/update via the AJAX cart API and open its drawer via API.
   ========================================================================== */
(function () {
  var cfgEl = document.getElementById('bogo-config');
  if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.eligible) return;
  var root = document.getElementById('bogo-offer-root');
  if (!root) return;

  var overlay = root.querySelector('[data-bogo-overlay]');
  var grid = root.querySelector('[data-bogo-grid]');
  var searchInput = root.querySelector('[data-bogo-search]');
  var emptyEl = root.querySelector('[data-bogo-empty]');
  var countEl = root.querySelector('[data-bogo-count]');
  var chipsWrap = root.querySelector('[data-bogo-chips]');
  var sizesWrap = root.querySelector('[data-bogo-sizes]');
  var tallyEl = root.querySelector('[data-bogo-tally]');
  var fillEl = root.querySelector('[data-bogo-fill]');
  var nudgeEl = root.querySelector('[data-bogo-nudge]');
  var doneBtn = root.querySelector('[data-bogo-done]');
  var boxWrap = root.querySelector('[data-bogo-box]');
  var boxRow = root.querySelector('[data-bogo-box-row]');
  var sizeStep = root.querySelector('[data-bogo-sizestep]');
  var sizeQ = root.querySelector('[data-bogo-ss-q]');
  var againStep = root.querySelector('[data-bogo-againstep]');
  var builderEl = root.querySelector('[data-bogo-builder]');

  var CATALOGUE = null, IMG_BASE = '', catLoading = false, catWaiters = [], byHandle = {};
  var state = { gender: 'all' };
  var activeSize = null, rootSize = null, rootVariant = null, triggerBtn = null;
  var rootLocked = true, cartCache = null;
  var basket = {};      // variantId -> { id, h, t, size, qty }  (desired TOTAL in cart)
  var existing = {};    // variantId -> qty already in the cart
  var boxEls = {};      // variantId -> box-row chip element (reused, not rebuilt)
  var filtered = [], rendered = 0, CHUNK = 30;

  /* ---- helpers ---------------------------------------------------------- */
  function availableSizes() { return ['15', '50', '100'].filter(function (s) { return CFG.variants[s]; }); }
  function sizeOfVariantId(id) { id = String(id); var v = CFG.variants || {}; for (var k in v) { if (String(v[k]) === id) return k; } return null; }
  function sizeFromText(t) { t = String(t || ''); if (/100/.test(t)) return '100'; if (/\b50\b|50\s*ml/.test(t)) return '50'; if (/\b15\b|15\s*ml/.test(t)) return '15'; return null; }
  function findForm() { return document.querySelector('form[action$="/cart/add"]:not([id^="product-form-installment"])'); }
  function selectedVariantId() { var f = findForm(), i = f && f.querySelector('input[name="id"], select[name="id"]'); return i ? i.value : (CFG.variants['100'] || CFG.variants['50'] || CFG.variants['15']); }
  function full(s) { return !s ? '' : (s.indexOf('http') === 0 ? s : IMG_BASE + s); }
  function img(url) { url = full(url); return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=320' : ''; }
  function clean(t) { return t.replace(/^Inspired [Bb]y\s*/, ''); }
  function isRootId(id) { return String(id) === String(rootVariant); }
  function isLockedRoot(id) { return rootLocked && String(id) === String(rootVariant); }   // only the pinned/locked root

  /* ---- AJAX cart -------------------------------------------------------- */
  function ec() { return window.EliteCart; }
  function openCartDrawer() {
    var e = ec();
    if (e && typeof e.openDrawerWithDataRefresh === 'function') { try { e.openDrawerWithDataRefresh(); return; } catch (_) {} }
    if (e && typeof e.openAppropriateCartWithDataRefresh === 'function') { try { e.openAppropriateCartWithDataRefresh(); return; } catch (_) {} }
    var link = document.querySelector('a.header__icon--cart, a[href$="/cart"]');
    if (link) { link.click(); return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { document.dispatchEvent(new CustomEvent('cart-update', { detail: c })); });
  }
  function addItems(items) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); }); }
  function updateQtys(updates) { return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); }); }

  /* ---- catalogue -------------------------------------------------------- */
  function loadCatalogue(cb) {
    if (CATALOGUE) { cb(CATALOGUE); return; }
    catWaiters.push(cb);
    if (catLoading) return; catLoading = true;
    fetch(CFG.catalogueUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { IMG_BASE = (d && d.base) || ''; CATALOGUE = (d && d.products) || []; CATALOGUE.forEach(function (p) { byHandle[p.h] = p; }); catWaiters.forEach(function (f) { f(CATALOGUE); }); catWaiters = []; })
      .catch(function () { CATALOGUE = []; catWaiters.forEach(function (f) { f(CATALOGUE); }); catWaiters = []; });
  }

  /* ---- cart seeding ----------------------------------------------------- */
  function eligibleCartItem(it) {
    var sz = sizeFromText(it.variant_title) || sizeFromText(it.title);
    if (!sz) return null;
    if (it.product_type && it.product_type !== 'Perfume') return null;
    if (/build your own|discovery|bundle|fragrance box|gift set|gift box|sample|sampler/i.test((it.product_title || it.title || '') + ' ' + (it.handle || ''))) return null;
    return sz;
  }
  function seedFromCart(cart) {
    (cart.items || []).forEach(function (it) {
      var sz = eligibleCartItem(it); if (!sz) return;
      existing[it.variant_id] = (existing[it.variant_id] || 0) + it.quantity;
      if (basket[it.variant_id]) basket[it.variant_id].qty = existing[it.variant_id];
      else basket[it.variant_id] = { id: it.variant_id, h: it.handle, t: it.product_title || it.title, size: sz, qty: it.quantity, img: (it.featured_image && it.featured_image.url) || it.image || '' };
    });
    if (existing[rootVariant]) basket[rootVariant].qty = existing[rootVariant];
  }
  function ensureRoot() {
    rootVariant = CFG.variants[rootSize];
    if (!basket[rootVariant]) basket[rootVariant] = { id: rootVariant, h: CFG.handle, t: CFG.title, size: rootSize, qty: 1 };
  }

  /* ---- basket math + mutation ------------------------------------------ */
  function perSize() { var c = {}; for (var k in basket) { var it = basket[k]; c[it.size] = (c[it.size] || 0) + it.qty; } return c; }
  function totals() { var c = perSize(), total = 0, free = 0; for (var s in c) { total += c[s]; free += Math.floor(c[s] / 2); } return { total: total, free: free, c: c }; }
  function qtyFor(p) { var v = p.v && p.v[activeSize]; return v && basket[v.id] ? basket[v.id].qty : 0; }

  function addPick(p) {
    var v = p.v && p.v[activeSize]; if (!v || !v.id) return;
    if (basket[v.id]) basket[v.id].qty++; else basket[v.id] = { id: v.id, h: p.h, t: p.t, size: activeSize, qty: 1, img: (p.v[activeSize] && p.v[activeSize].img) || p.img };
    updateProgress(); markOneCard(p); renderBox();   // light: bar + just this card + incremental box
  }
  function decById(id) {                       // remove one (locked root can't be removed)
    if (isLockedRoot(id)) return;
    var h = basket[id] && basket[id].h;
    if (basket[id]) { basket[id].qty--; if (basket[id].qty <= 0) delete basket[id]; }
    updateProgress(); if (h) markByHandle(h); renderBox();
  }
  function syncUI() { updateProgress(); renderBox(); }
  function markOneCard(p) { var c = grid.querySelector('.bogo__card[data-handle="' + p.h + '"]:not(.bogo__card--root)'); if (c) markCard(p, c); }
  function markByHandle(h) { var p = byHandle[h]; if (!p) return; var c = grid.querySelector('.bogo__card[data-handle="' + h + '"]:not(.bogo__card--root)'); if (c) markCard(p, c); }

  function updateProgress() {
    var t = totals(), c = t.c[activeSize] || 0, label = CFG.sizeLabels[activeSize];
    tallyEl.textContent = t.total + (t.total === 1 ? ' bottle' : ' bottles') + ' · ' + t.free + ' free';
    if (c % 2 === 1) { fillEl.style.width = '60%'; nudgeEl.textContent = 'Add 1 more ' + label + ' — it’s FREE 🎁'; }
    else if (c > 0) { fillEl.style.width = '100%'; nudgeEl.textContent = 'Pair complete! Add 2 more ' + label + ' for another free.'; }
    else { fillEl.style.width = '0%'; nudgeEl.textContent = 'Add a 2nd ' + label + ' and it’s free.'; }
    if (doneBtn) doneBtn.textContent = 'Done · View cart (' + t.total + ')';
  }

  /* ---- "your box" card row --------------------------------------------- */
  function buildChip(it) {
    var rootCard = isLockedRoot(it.id);
    var src = it.img;                                    // resolve image from the catalogue if the entry has none (e.g. pre-seeded root)
    if (!src && byHandle[it.h] && byHandle[it.h].v) { var bv = byHandle[it.h].v[it.size]; src = (bv && bv.img) || byHandle[it.h].img || ''; }
    var el = document.createElement('div');
    el.className = 'bogo__chip-card' + (rootCard ? ' is-root' : '');
    el.setAttribute('data-id', it.id);
    el.innerHTML =
      '<span class="bogo__chip-img">' + (src ? '<img alt="" src="' + img(src) + '">' : '') + '</span>' +
      '<span class="bogo__chip-info"><span class="bogo__chip-name">' + clean(it.t) + '</span><span class="bogo__chip-meta">' + CFG.sizeLabels[it.size] + (it.qty > 1 ? ' ×' + it.qty : '') + '</span></span>' +
      (rootCard ? '<span class="bogo__chip-lock" title="Your scent">🔒</span>' : '<button type="button" class="bogo__chip-x" data-remove="' + it.id + '" aria-label="Remove">×</button>');
    return el;
  }
  function renderBox() {                                  // incremental: reuse chip elements, don't re-decode images
    if (!boxRow) return;
    var ids = Object.keys(basket);
    if (!ids.length) { boxWrap.hidden = true; boxRow.innerHTML = ''; boxEls = {}; return; }
    boxWrap.hidden = false;
    Object.keys(boxEls).forEach(function (id) { if (!basket[id]) { if (boxEls[id] && boxEls[id].parentNode) boxEls[id].parentNode.removeChild(boxEls[id]); delete boxEls[id]; } });
    var items = ids.map(function (k) { return basket[k]; }).sort(function (a, b) { if (isLockedRoot(a.id)) return -1; if (isLockedRoot(b.id)) return 1; return a.t.localeCompare(b.t); });
    items.forEach(function (it, idx) {
      var el = boxEls[it.id];
      if (!el) { el = buildChip(it); boxEls[it.id] = el; }
      else { var meta = el.querySelector('.bogo__chip-meta'); if (meta) meta.textContent = CFG.sizeLabels[it.size] + (it.qty > 1 ? ' ×' + it.qty : ''); }
      if (boxRow.children[idx] !== el) boxRow.insertBefore(el, boxRow.children[idx] || null);
    });
  }

  /* ---- grid rendering --------------------------------------------------- */
  var imgObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.isIntersecting) { var i = en.target, s = i.getAttribute('data-src'); if (s) { i.src = s; i.removeAttribute('data-src'); } imgObserver.unobserve(i); } });
  }, { rootMargin: '300px' }) : null;
  function observeImgs() { if (imgObserver) grid.querySelectorAll('img[data-src]').forEach(function (i) { imgObserver.observe(i); }); else grid.querySelectorAll('img[data-src]').forEach(function (i) { i.src = i.getAttribute('data-src'); }); }
  function pickLabel(q) { return q > 0 ? '✓ In your cart' : '+ Add'; }

  function buildCard(p, isRoot) {
    var sz = isRoot ? rootSize : activeSize;
    var vsrc = (p.v[sz] && p.v[sz].img) || p.img;
    var q = isRoot ? (basket[rootVariant] ? basket[rootVariant].qty : 1) : qtyFor(p);
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'bogo__card' + (q > 0 ? ' is-picked' : '') + (isRoot ? ' bogo__card--root bogo__card--locked' : '');
    card.setAttribute('data-handle', p.h);
    card.innerHTML =
      (isRoot ? '<span class="bogo__root-tag">Your scent · ' + CFG.sizeLabels[rootSize] + '</span>' : '') +
      '<span class="bogo__img">' + (vsrc ? '<img alt="" data-src="' + img(vsrc) + '">' : '') + '</span>' +
      '<span class="bogo__name">' + clean(p.t) + '</span>' +
      '<span class="bogo__free">' + (isRoot ? '✓ In your cart' : pickLabel(q)) + '</span>' +
      (isRoot
        ? '<span class="bogo__qty bogo__qty--locked" aria-label="Locked in your cart"><span class="bogo__lock">🔒</span></span>'
        : '<span class="bogo__qty"' + (q > 0 ? '' : ' hidden') + '><button type="button" class="bogo__qminus" aria-label="Remove one">−</button><b data-qty>' + q + '</b></span>');
    if (!isRoot) {
      card.addEventListener('click', function (e) { if (e.target.closest('.bogo__qminus')) return; addPick(p); });
      card.querySelector('.bogo__qminus').addEventListener('click', function (e) { e.stopPropagation(); decById(p.v[activeSize] && p.v[activeSize].id); });
    }
    return card;
  }
  function markCard(p, card) {
    var id = p.v && p.v[activeSize] ? p.v[activeSize].id : null;
    var q = id && basket[id] ? basket[id].qty : 0;
    card.classList.toggle('is-picked', q > 0);
    var pill = card.querySelector('.bogo__free'); if (pill) pill.textContent = pickLabel(q);
    var qty = card.querySelector('.bogo__qty'); if (qty) qty.hidden = q <= 0;
    var b = card.querySelector('[data-qty]'); if (b) b.textContent = q;
  }
  function currentList() {
    if (!CATALOGUE) return [];
    var q = (searchInput.value || '').trim().toLowerCase(), g = state.gender;
    return CATALOGUE.filter(function (p) {
      if (!p.v || !p.v[activeSize]) return false;
      if (g !== 'all' && p.g !== g) return false;
      if (q && p.t.toLowerCase().indexOf(q) === -1) return false;
      return true;
    });
  }
  function renderGrid() {
    if (!CATALOGUE) { grid.innerHTML = skeletons(12); countEl.textContent = ''; emptyEl.hidden = true; return; }
    var rootEntry = null;
    if (rootLocked) { for (var i = 0; i < CATALOGUE.length; i++) { var p = CATALOGUE[i]; if (p.h === CFG.handle && p.v && p.v[rootSize]) { rootEntry = p; break; } } }
    filtered = currentList().filter(function (p) { return !(rootLocked && p.h === CFG.handle); });
    rendered = 0; grid.innerHTML = '';
    var total = filtered.length + (rootEntry ? 1 : 0);
    countEl.textContent = total ? (total + ' fragrances') : '';
    if (rootEntry) grid.appendChild(buildCard(rootEntry, true));
    if (!total) { emptyEl.hidden = false; return; }
    emptyEl.hidden = true;
    appendChunk(); observeImgs();
  }
  function appendChunk() {
    var slice = filtered.slice(rendered, rendered + CHUNK); rendered += slice.length;
    var frag = document.createDocumentFragment();
    slice.forEach(function (p) { frag.appendChild(buildCard(p, false)); });
    grid.appendChild(frag); observeImgs();
  }
  function skeletons(n) { var s = ''; for (var i = 0; i < n; i++) s += '<span class="bogo__card bogo__card--sk"><span class="bogo__img"></span></span>'; return s; }

  /* ---- chips ------------------------------------------------------------ */
  function setSize(s) { activeSize = s; if (sizesWrap) sizesWrap.querySelectorAll('[data-bogo-size]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-bogo-size') === s); }); renderGrid(); updateProgress(); renderBox(); }
  function syncChips() { if (chipsWrap) chipsWrap.querySelectorAll('[data-bogo-gender]').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-bogo-gender') === state.gender); }); }

  /* ---- open / done ------------------------------------------------------ */
  function onBogoClick() {
    basket = {}; existing = {}; boxEls = {}; if (boxRow) boxRow.innerHTML = '';
    state.gender = 'all'; searchInput.value = ''; syncChips();
    if (doneBtn) doneBtn.disabled = false;
    overlay.hidden = false; document.documentElement.classList.add('bogo-open');
    if (sizeStep) sizeStep.hidden = true; if (againStep) againStep.hidden = true; if (builderEl) builderEl.hidden = true;
    // decide from the cart FIRST: if they already own this scent, ask add-another vs different; else pick size
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCache = cart;
        var inCart = (cart.items || []).some(function (it) { return it.handle === CFG.handle && eligibleCartItem(it); });
        if (inCart && againStep) showAgainStep();
        else showSizeStep('first');
      })
      .catch(function () { showSizeStep('first'); });
  }
  function showSizeStep(mode) {
    if (againStep) againStep.hidden = true;
    if (builderEl) builderEl.hidden = true;
    if (sizeQ) sizeQ.innerHTML = (mode === 'another')
      ? 'Add another <strong>' + clean(CFG.title) + '</strong> — pick the size'
      : 'Adding <strong>' + clean(CFG.title) + '</strong> as your first bottle';
    if (sizeStep) {
      sizeStep.hidden = false;
      var sug = sizeOfVariantId(selectedVariantId());
      sizeStep.querySelectorAll('[data-bogo-pick-size]').forEach(function (b) { b.classList.toggle('is-suggested', b.getAttribute('data-bogo-pick-size') === sug); });
    }
  }
  function chooseRootSize(size) { startBuilder(size, true, cartCache); }   // size picked -> build with locked root (+1 if already owned)
  function showAgainStep() {
    if (sizeStep) sizeStep.hidden = true;
    if (builderEl) builderEl.hidden = true;
    if (againStep) againStep.hidden = false;
  }
  function startBuilder(size, locked, cart) {
    rootLocked = locked; rootSize = size; rootVariant = CFG.variants[size];
    basket = {}; existing = {}; boxEls = {}; if (boxRow) boxRow.innerHTML = '';
    if (cart) seedFromCart(cart);
    if (locked) {
      if (!basket[rootVariant]) basket[rootVariant] = { id: rootVariant, h: CFG.handle, t: CFG.title, size: size, qty: 1 };
      else basket[rootVariant].qty = (existing[rootVariant] || 0) + 1;   // "add another" — one more than what's in the cart
    }
    if (sizeStep) sizeStep.hidden = true;
    if (againStep) againStep.hidden = true;
    if (builderEl) builderEl.hidden = false;
    setSize(size);
    loadCatalogue(function () { renderGrid(); renderBox(); });
    renderGrid(); syncUI();
    setTimeout(function () { searchInput.focus(); }, 80);
  }
  function closeOverlay() { overlay.hidden = true; document.documentElement.classList.remove('bogo-open'); }
  function done() {
    var ids = {}, adds = [], updates = {}, hasUpd = false;
    for (var a in basket) ids[a] = 1;
    for (var b in existing) ids[b] = 1;
    Object.keys(ids).forEach(function (id) {
      var target = basket[id] ? basket[id].qty : 0, current = existing[id] || 0;
      if (target === current) return;
      if (current === 0) adds.push({ id: Number(id), quantity: target });
      else { updates[id] = target; hasUpd = true; }     // increase, decrease or remove (0)
    });
    if (!adds.length && !hasUpd) { openCartDrawer(); closeOverlay(); return; }
    doneBtn.disabled = true; doneBtn.textContent = 'Updating cart…';
    var chain = Promise.resolve();
    if (hasUpd) chain = chain.then(function () { return updateQtys(updates); });
    if (adds.length) chain = chain.then(function () { return addItems(adds); });
    chain.then(function () { openCartDrawer(); closeOverlay(); })
      .catch(function () { doneBtn.disabled = false; updateProgress(); countEl.textContent = 'Something went wrong, please try again.'; });
  }

  /* ---- PDP button ------------------------------------------------------- */
  function injectButtons() {
    var form = findForm();
    if (!form || form.querySelector('[data-bogo-trigger]')) return true;
    var submit = form.querySelector('button[name="add"], [data-btn-addToCart], button[type="submit"]');
    if (!submit) return false;
    var wrap = document.createElement('div'); wrap.className = 'bogo__cta';
    wrap.innerHTML = '<button type="button" class="bogo__btn--bogo" data-bogo-trigger aria-label="Buy one get one free, build your box">' +
      '<span class="bogo__shine"></span>' +
      '<span class="bogo__bogo-top"><span class="bogo__gift">🎁</span><span class="bogo__bogo-main">BUY 1 GET 1 FREE</span></span>' +
      '<span class="bogo__bogo-cta">Tap to build your box <span class="bogo__arrow">→</span></span></button>';
    submit.parentNode.insertBefore(wrap, submit);
    submit.style.setProperty('display', 'none', 'important');
    triggerBtn = wrap.querySelector('[data-bogo-trigger]');
    triggerBtn.addEventListener('click', onBogoClick);
    return true;
  }

  /* ---- wire up ---------------------------------------------------------- */
  if (searchInput) { var t; searchInput.addEventListener('input', function () { clearTimeout(t); t = setTimeout(renderGrid, 110); }); }
  if (chipsWrap) chipsWrap.addEventListener('click', function (e) { var c = e.target.closest('[data-bogo-gender]'); if (!c) return; state.gender = c.getAttribute('data-bogo-gender'); syncChips(); renderGrid(); });
  if (sizesWrap) sizesWrap.addEventListener('click', function (e) { var s = e.target.closest('[data-bogo-size]'); if (s) setSize(s.getAttribute('data-bogo-size')); });
  if (sizeStep) sizeStep.addEventListener('click', function (e) { var s = e.target.closest('[data-bogo-pick-size]'); if (s) chooseRootSize(s.getAttribute('data-bogo-pick-size')); });
  if (againStep) againStep.addEventListener('click', function (e) {
    if (e.target.closest('[data-bogo-again-same]')) showSizeStep('another');          // pick size, then add another as locked root
    else if (e.target.closest('[data-bogo-again-diff]')) { var av = availableSizes(); startBuilder(sizeOfVariantId(selectedVariantId()) || av[av.length - 1] || '100', false, cartCache); }
  });
  if (boxRow) boxRow.addEventListener('click', function (e) { var x = e.target.closest('[data-remove]'); if (x) decById(x.getAttribute('data-remove')); });
  if (grid) grid.addEventListener('scroll', function () { if (CATALOGUE && rendered < filtered.length && grid.scrollTop + grid.clientHeight >= grid.scrollHeight - 400) appendChunk(); });
  if (doneBtn) doneBtn.addEventListener('click', done);
  root.querySelectorAll('[data-bogo-close]').forEach(function (b) { b.addEventListener('click', closeOverlay); });
  if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) closeOverlay(); });

  if (!injectButtons()) { var tries = 0, iv = setInterval(function () { if (injectButtons() || ++tries > 40) clearInterval(iv); }, 250); }
  var warm = function () { loadCatalogue(function () {}); };
  if ('requestIdleCallback' in window) { requestIdleCallback(warm, { timeout: 2500 }); } else { setTimeout(warm, 1500); }
})();
